module.exports = __webpack_public_path__ + "img/hh.70ecb9f8.png";